module.exports = __webpack_public_path__ + "static/media/Drawing_Tech_Setup.8980d734.svg";